<template>
  <div v-if="product != null && this.mobile == false" class="product-card d-none d-lg-block" :class="product.offer != null && product.offer.cluster_id > 0 ? 'cluster':''" @click="Details()">
    <div class="text-cashback" v-if="product.offer != null && product.offer.cashback > 0"><b>CASHBACK ({{ $formatNumber(product.offer.cashback, {style: 'currency', currency: 'BRL'}) }})</b></div>
    <div class="product-top" :class="product.offer != null && product.offer.cashback > 0 ? '': 'full-product-top'">      
      <div :id="product.sku" class="product-img" :class="product.offer != null && product.offer.cashback > 0 ? '': 'radius'" @click.stop="modelImage = true">
        <ImageProduct :image="product.image"></ImageProduct>
        <v-dialog v-model="modelImage" width="800px">
          <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="modelImage = false"></v-btn>
          <div style="min-height: 600px; background-color: white;">
            <ImageProduct :image="product.image"></ImageProduct>
          </div>
        </v-dialog>
      </div>
      <div class="product-like">
        <div v-if="getLikeByIdProduto(product.sku)" @click.stop="removeLike()">
          <Svgs :icon="'coracao-fill'" :color="'fill-color-red'" :width="30" :height="30"></Svgs>
        </div>
        <div v-else @click.stop="setLike()">
          <Svgs :icon="'coracao'" :color="'fill-color-0'" :width="30" :height="30"></Svgs>
        </div>
      </div>
      <div class="product-discount" v-if="product.offer != null && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0) && (parseFloat(100 - (product.offer.offer_connect * 100 / product.offer.offer_price)) > 1)">
        <div class="font-weight-bold">
          -{{ parseFloat(100 - (product.offer.offer_connect * 100 / product.offer.offer_price)).toFixed(0) }}%
        </div>
      </div>
      <div class="product-discount-offer" v-if="product.offer != null && (product.offer.offer_connect == 0 || (product.offer.is_offer_unlimited == 0 && product.offer.amount_connect == 0) ) && (parseFloat(100 - (product.offer.offer_price * 100 / product.price)) > 1)">
        <div class="font-weight-bold">
          -{{ parseFloat(100 - (product.offer.offer_price * 100 / product.price)).toFixed(0) }}%
        </div>
      </div>
      <div class="product-banner" v-if="product.offer != null && product.offer.offer_connect > 0 && product.offer.is_offer_club == 1 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">
        <img v-if="product.offer.cluster_id > 0" src="../assets/images/exclusividade_preco-para-vc.png">
        <img v-else src="../assets/images/exclusividade_preco-clube.png">
      </div>
    </div>
    <div class="product-preco-inicial">
      <del v-if="product.offer != null && product.offer.is_offer_club == 1 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">{{ $formatNumber(calcPrice(product.offer.offer_price), {style: 'currency', currency: 'BRL'}) }}</del>
      <del v-else-if="product.offer != null && product.price > product.offer.offer_price">{{ $formatNumber(calcPrice(product.price), {style: 'currency', currency: 'BRL'}) }}</del>
    </div>
    <div class="product-preco-final">
      <span v-if="product.offer != null && product.offer.is_offer_club == 1 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">{{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }}</span> 
      <span v-else>{{ $formatNumber(calcPrice(product.offer != null ? product.offer.offer_price : product.price), {style: 'currency', currency: 'BRL'}) }}</span> 
      <small class="ms-1" v-if="kgund == 1">kg</small><small class="ms-1" v-else>und</small>
    </div>
    <div class="product-kgund">
      <div class="product-equivalencia" v-if="product.is_kg == 1 && product.cfg != null && product.cfg.net_weight > 0">
        Uma unidade é aproximadamente {{ textPesoLiq }}
      </div>
      <div class="product-btn-kgund" v-if="product.is_kg == 1 && product.cfg != null && product.cfg.net_weight > 0">
        <v-btn-toggle variant="outlined" mandatory @click.stop="changeKgUnd()">
          <v-btn flat size="x-small" :class="kgund == 0 ? 'bg-color-1 text-white' : ''">
            <b>und</b>
          </v-btn>
          <v-btn flat size="x-small" :class="kgund == 1 ? 'bg-color-1 text-white' : ''">
            <b>kg</b>
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div class="product-title">{{ product.name }}</div>
    <div class="product-obs">
      <span v-if="product.offer != null && product.offer.obs != ''">{{ product.offer.obs }}</span>
    </div>
    <div class="product-ativacao">
      <div v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">
      <v-btn variant="flat" block size="x-large" class="br-5 bg-color-2" @click.stop="activate()" v-if="product.offer.dh_activated == null">
        <div class="text-btn-ativacao">
          ATIVE E PAGUE {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }}<br>
          <small>PREÇO</small><small class="ms-1" v-if="kgund == 1">KG</small><small class="ms-1" v-else>UND</small>
        </div>
      </v-btn>
      <v-btn variant="flat" block size="x-large" class="br-5 bg-color-0" v-else>
        <div class="text-btn-ativado">
          <b v-if="textoCupom == 1">CUPOM ATIVADO</b><b v-else>OFERTA ATIVADA</b> <span class="font-weight-bold">{{ $formatDate(product.offer.dh_activated, { day: '2-digit', month: '2-digit' }) }} {{ $formatTime(product.offer.dh_activated).replace(":", "h") }}</span><br>
          {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }} <small v-if="kgund == 1">kg</small><small v-else>und</small>
        </div>
      </v-btn>
      </div>
    </div>
    <div class="product-oferta-limite">
      <div v-if="product.offer != null">
        <span class="text-xxsmall" v-if="product.offer.amount_connect > 0 && product.offer.offer_connect > 0">Você tem {{ limiteQtd(product.offer.amount_connect) }} (até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }})</span>
        <span class="text-xxsmall" v-else>Oferta válida até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }}</span>
      </div>
    </div>
    <div class="product-btn d-flex align-end" v-if="product.is_sale">
      <v-btn variant="outlined" block class="br-5 text-color-2" @click.stop="chooseItem();" v-if="product.offer != null && product.offer.is_offer_family == 1">ESCOLHER</v-btn>
      <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="textQtd" readonly  @keyup="updateItem()" class="text-center border-color-1" v-else-if="item != null && item.cart.amount > 0 && kgund == 1" @click.stop="">
        <template v-slot:prepend-inner>
          <div @click.stop="removeItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
            <v-icon icon="mdi-minus"/>
          </div>
        </template>
        <template v-slot:append-inner>
          <div @click.stop="addItem(true)" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
            <v-icon icon="mdi-plus"/>
          </div>
        </template>
      </v-text-field>
      <v-text-field variant="outlined" density="compact" :hide-details="true" v-maska:[maskqtd] v-model="qtd" :readonly="product.cfg != null && product.cfg.fractional_amount > 1 ? true: false" class="text-center border-color-1" @keyup="updateItem()" v-else-if="item != null && item.cart.amount > 0 && kgund == 0" @click.stop="">
        <template v-slot:prepend-inner>
          <div @click.stop="removeItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
            <v-icon icon="mdi-minus"/>
          </div>
        </template>
        <template v-slot:append-inner>
          <div @click.stop="addItem(true)" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
            <v-icon icon="mdi-plus"/>
          </div>
        </template>
      </v-text-field>
      <v-btn variant="outlined" block class="br-5 text-color-2 border" @click.stop="addItem();" v-else>ADICIONAR</v-btn>
    </div>
    <div class="product-btn d-flex align-end" v-else>
      <v-btn block flat class="br-5 bg-color-black text-color-white opacity-85">EXCLUSIVO LOJA FÍSICA</v-btn>
    </div>
  </div>
  <v-row v-if="product != null && this.mobile == true" no-gutters class="d-flex d-lg-none mb-2">
    <v-col class="pr-1 product-card-mobile pa-2" @click="$router.push('/details/'+product.barcode)" :class="product.offer != null && product.offer.cluster_id > 0 ? 'cluster' + (product.is_sale ? ' v-col-10': ' v-col-12'): (product.is_sale ? 'v-col-10': 'v-col-12')">
      <div class="product-mobile-banner" v-if="product.offer != null && product.offer.offer_connect > 0 && (product.offer.cluster_id > 0 || product.offer.is_offer_club == 1) && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">
        <img v-if="product.offer.cluster_id > 0" src="../assets/images/exclusividade_preco-para-vc.png">
        <img v-else-if="product.offer.is_offer_club == 1" src="../assets/images/exclusividade_preco-clube.png">
      </div>
      <v-row no-gutters >
        <v-col :id="product.sku" cols="3" class="px-0 mt-3 d-flex align-center">
          <ImageProduct :image="product.image"></ImageProduct>
        </v-col>
        <v-col cols="8" class="px-0 mt-3">
          <div class="product-mobile-title">{{ product.name }}</div>
          <div class="product-mobile-preco-inicial">
            <del v-if="product.offer != null && product.offer.is_offer_club == 1 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">De: {{ $formatNumber(calcPrice(product.offer.offer_price), {style: 'currency', currency: 'BRL'}) }}</del>
            <del v-else-if="product.offer != null">De: {{ $formatNumber(calcPrice(product.price), {style: 'currency', currency: 'BRL'}) }}</del>
          </div>
          <div class="product-mobile-preco-final">
            <span v-if="product.offer != null && product.offer.is_offer_club == 1 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">Por: {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }}</span> 
            <span v-else>Por: {{ $formatNumber(calcPrice(product.offer != null ? product.offer.offer_price : product.price), {style: 'currency', currency: 'BRL'}) }}</span> 
            <small class="ms-1" v-if="kgund == 1">kg</small><small class="ms-1" v-else>und</small>
          </div>
          <div class="product-mobile-obs text-xsmall">
            <span v-if="product.offer != null && product.offer.obs != ''">{{ product.offer.obs }}</span>
          </div>
          <div class="product-mobile-kgund" v-if="product.is_kg == 1 && product.cfg != null && product.cfg.net_weight > 0">
            <div class="product-btn-kgund">
              <v-btn-toggle variant="outlined" mandatory @click="changeKgUnd()">
                <v-btn flat size="x-small" :class="kgund == 0 ? 'bg-color-1 text-white' : ''">
                  <b>und</b>
                </v-btn>
                <v-btn flat size="x-small" :class="kgund == 1 ? 'bg-color-1 text-white' : ''">
                  <b>kg</b>
                </v-btn>
              </v-btn-toggle>
            </div>
            <div class="product-equivalencia">
              Uma unidade é<br>aproximadamente {{ textPesoLiq }}
            </div>
          </div>
        </v-col>
        <v-col cols="1" class="px-0 mt-3 d-flex flex-wrap product-card-mobile-icons">
          <div>
            <v-icon icon="mdi-dots-vertical" class="text-color-0"></v-icon>
          </div>
          <div v-if="getLikeByIdProduto(product.sku)" @click.stop="removeLike()">
            <Svgs :icon="'coracao-fill'" :color="'fill-color-red'" :width="30" :height="30"></Svgs>
          </div>
          <div v-else @click.stop="setLike()">
            <Svgs :icon="'coracao'" :color="'fill-color-0'" :width="30" :height="30"></Svgs>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12" class="py-0 mt-2" v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && (product.offer.is_offer_unlimited || product.offer.amount_connect > 0)">
          <div class="product-mobile-ativacao">
            <v-btn variant="flat" block size="x-large" class="bg-color-2 px-0" @click.stop="activate()" v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && product.offer.dh_activated == null">
              <div class="discount-btn-mobile-ativacao">
                <div>
                - {{ parseFloat(100 - (product.offer.offer_connect * 100 / product.offer.offer_price)).toFixed(0) }}%
                </div>
              </div>
              <div class="text-btn-mobile-ativacao">
                ATIVE E PAGUE {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }}<br>
                <small>PREÇO UNIDADE</small>
              </div>
            </v-btn>
            <v-btn variant="flat" block size="x-large" class="br-5 bg-color-0" v-if="product.offer != null && product.offer.is_offer_club == 0 && product.offer.offer_connect > 0 && product.offer.dh_activated != null">
              <div class="text-btn-ativado">
                <b v-if="textoCupom == 1">CUPOM ATIVADO</b><b v-else>OFERTA ATIVADA</b> <b>{{ $formatDate(product.offer.dh_activated, { day: '2-digit', month: '2-digit' }) }} {{ $formatTime(product.offer.dh_activated).replace(":", "h") }}</b><br>
                {{ $formatNumber(calcPrice(product.offer.offer_connect), {style: 'currency', currency: 'BRL'}) }} <small class="ms-1" v-if="kgund == 1">kg</small><small class="ms-1" v-else>und</small>
              </div>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" class="py-0 mt-1" v-if="product.is_sale == false">
          <v-btn block flat class="br-5 bg-color-black text-color-white mb-2 opacity-85">EXCLUSIVO LOJA FÍSICA</v-btn>
        </v-col>
        <v-col cols="12" class="pt-0" v-if="product.offer != null">
          <div class="product-mobile-oferta-limite">
            <span class="text-xsmall" v-if="product.offer.amount_connect > 0 && product.offer.offer_connect > 0">Você tem {{ limiteQtd(product.offer.amount_connect) }} (até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }})</span>
            <span class="text-xsmall" v-else>Oferta válida até {{ $formatDate(product.offer.offer_finish_date+" 00:00:00") }}</span>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col :class="product.is_sale ? 'v-col-2': 'd-none'">
      <v-row no-gutters class="product-card-mobile py-0 px-2" :class="product.offer != null && product.offer.cluster_id > 0 ? 'cluster':''">
        <v-col class="d-flex flex-wrap align-space-between justify-center">
          <div class="w-100 d-flex justify-center align-end">
            <v-btn icon="mdi-plus" flat class="text-color-2 mini-size" @click.stop="product.offer != null && product.offer.is_offer_family == 1 ? chooseItem() : addItem()"></v-btn>
          </div>
          <div class="w-100 d-flex justify-center">
            <span v-if="kgund == 1" class="text-small mt-3 mb-2 text-color-black">{{ textQtd }}</span>
            <v-text-field :hide-details="true" v-model="qtd" v-maska:[maskqtd] variant="solo" v-else :disabled="((product.offer != null && product.offer.is_offer_family == 1) || (product.cfg != null && product.cfg.fractional_amount > 1))" flat class="product-qtd-textfield" @keyup="updateItem()"></v-text-field>
          </div>
          <div class="w-100 d-flex justify-center">
            <v-btn icon="mdi-minus" flat class="text-color-2 mini-size" @click.stop="product.offer != null && product.offer.is_offer_family == 1 ? chooseItem() : removeItem()"></v-btn>
          </div>
          <div class="w-100 d-flex justify-center">
            <v-btn class="text-color-2 mini-size" flat @click.stop="product.offer != null && product.offer.is_offer_family == 1 ? removeFamily() : removeAll()">
               <Svgs :icon="'lixeira'" :color="'fill-color-2'" :width="20" :height="20"></Svgs>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <DialogFamily :fechar="fechar" :model="modelFamily" :produto="product"></DialogFamily>
</template>

<script>
import ImageProduct from '@/components/ImageProduct.vue';
import DialogFamily from '@/components/DialogFamily.vue';
import Svgs from '@/components/Svgs.vue';
import { mapGetters, mapActions } from 'vuex';
import jQuery from 'jquery';
export default {
  name: 'Product',
  components: {
    ImageProduct,
    DialogFamily,
    Svgs
  },
  props: {
    product: {
      type: Object,
      default: null
    },
    notImage: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      textoCupom: import.meta.env.VITE_IS_TEXTO_ATIVE_O_CUPOM,
      kgund: 0,
      premio: null,
      qtd: 0,
      qtd_buffer: 0,
      mobile: false,
      modelFamily: false,
      modelImage: false,
      maskqtd: {
        mask: "####",
      },
    }
  },
  computed: {
    ...mapGetters('main', {
      getConfig: 'getConfig'
    }),
    ...mapGetters('cart', {
      getItemById: 'getItemById',
      getTotalFamily: 'getTotalFamily'
    }),
    ...mapGetters('products', {
      getLikeByIdProduto: 'getLikeByIdProduto'
    }),
    item: function() {
      let retorno = this.product ? this.getItemById(this.product.sku) : null;
      return retorno ? JSON.parse(JSON.stringify(retorno)) : null;
    },
    textPesoLiq: function () {
      if (this.product.cfg != null && this.product.cfg.net_weight > 0) {
        if (this.product.cfg.net_weight < 1) {
            return parseFloat((this.product.cfg.net_weight * 1000))+'g';
        } else {
            return Number.isInteger(this.product.cfg.net_weight) ? (parseFloat(this.product.cfg.net_weight)+'kg').replace(".", ",") : (parseFloat(this.product.cfg.net_weight).toFixed(3)+'kg').replace(".", ",")
        }
      } else {
        return '';
      }
    },
    textQtd: function () {
      if (this.qtd < 1) {
          return Number(Math.round((this.qtd * 1000) + 'e0') + 'e-0')+'g';
      } else {
          return Number.isInteger(this.qtd) ? (Number(Math.round((this.qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((this.qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
      }
    },
    totalFamily(){
      if(this.product.offer != null && this.product.offer.is_offer_family == 1){
        return this.getTotalFamily(this.product.offer.offer_id);
      } else {
        return 0;
      }
    }
  },
  watch: {
    "product"() {
      this.kgund = this.product.is_kg == 1;
      if(this.product.imghash != ''){
        this.getImage({ sku: this.product.sku, imghash: "t-"+this.product.imghash });
      }
    },
    'item'(i) {
      this.qtd = i != null ? i.cart.amount : 0;
    },
    totalFamily(v){
      this.qtd = v;
    },
    'modelImage'(i){
      if(i){
        this.product.image = "";
        this.getImageCarousel({ sku: this.product.sku, imghash: this.product.imghash }).then(function(image){
          this.product.image = image;
        }.bind(this));
      }
    }
  },
  methods: {
    ...mapActions('products', {
      getImage: 'getImage',
      getImageCarousel: 'getImageCarousel',
      setLikeProduto: 'setLikeProduto',
      removeLikeProduto: 'removeLikeProduto',
      addProduct: 'addProduct',
      connectActivate: 'connectActivate',
      loadFamily: 'loadFamily'
    }),
    ...mapActions('cart', {
      updateItemCart: 'updateItemCart',
      removeAllFamily: 'removeAllFamily'
    }),
    limiteQtd: function (qtd) {
      if(this.product.is_kg == 1 && this.kgund == 1){
        if (qtd < 1) {
            return Number(Math.round((qtd * 1000) + 'e0') + 'e-0')+'g';
        } else {
            return Number.isInteger(qtd) ? (Number(Math.round((qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
        }
      } else if(this.product.is_kg == 1 && this.product.cfg != null && this.kgund == 0){
        qtd = qtd / this.product.cfg.net_weight;
        if (qtd == 1) {
          return qtd + " unidade";
        } else {
          return qtd + " unidades";
        }
      } else {
        if (qtd == 1) {
          return qtd + " unidade";
        } else {
          return qtd + " unidades";
        }
      }
    },
    changeKgUnd(){
      if(this.qtd > 0){
        let qtd = 0;
        if(this.product.is_kg == 1 && this.product.cfg != null){
          if (this.kgund == 1) {
            this.qtd_buffer = this.qtd;
            qtd = Number(Math.round((parseFloat(this.qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
            qtd = qtd < 1 ? 1 : qtd;
          } else if(this.qtd_buffer > 0){
            qtd = this.qtd_buffer;
            this.qtd_buffer = 0;
          } else {
            qtd = parseFloat(this.qtd) * parseFloat(this.product.cfg.net_weight);
          }
          this.kgund = this.kgund == 1 ? 0 : 1;
          qtd = this.verifyMinimum(qtd, qtd);
          this.setQtd(qtd);
        }
      } else {
        this.kgund = this.kgund == 1 ? 0 : 1;
      }
    },
    calcPrice(price){
      if (this.product.is_kg == 1 && this.kgund == 0 && this.product.cfg != null && this.product.cfg.net_weight > 0) {
        price = price * this.product.cfg.net_weight;
      } 
      return price;
    },
    activate(){
      this.activateAction(true, true);
    },
    activateAction: function(r, add){
      if(r){
        if(this.getConfig.isu > 0){
          this.connectActivate(this.product, add).then(function (retorno){
            this.product.offer.dh_activated = retorno;
            if(add != true){
              this.addItem(true);
            }
          }.bind(this));
        } else {
          this.emitter.emit('dialogLogin');
        }
      } else {
        this.addItem(true);
      }
    },
    Details(){
      this.addProduct(this.product);
      this.$router.push('/details/'+this.product.barcode);
    },
    checkLayout(){
      var val = window.innerWidth;
      if (parseFloat(val) >= 1280) {
          this.mobile = false;
      } else {
          this.mobile = true;
      }
    },
    setQtd(qtd){
      if(qtd == null){
        qtd = this.product.is_kg == 1 && this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
      }
      if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
        this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        this.qtd = this.product.limit_quantity;
      } else {
        this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
          this.qtd_buffer = 0;
          this.emitter.emit('sendCart');
        }.bind(this));
      }
    },
    updateItem(){
      let qtd = this.verifyMinimum(this.qtd, this.qtd);
      this.qtd = qtd;
      this.setQtd(parseFloat(this.qtd));
    },
    addItem(add){
      if(add == undefined && this.qtd == 0 && this.product.offer != null && this.product.offer.is_offer_club == 1 && this.product.offer.offer_connect > 0 && this.product.offer.dh_activated == null){
        this.activateAction(true, true);
      }
      if(add == undefined && this.qtd == 0 && this.product.offer != null && this.product.offer.is_offer_club == 0 && this.product.offer.offer_connect > 0 && this.product.offer.dh_activated == null){
        this.emitter.emit('dialogMessage', { title: "Ative e Pague!", message: "Deseja ativar o desconto e economizar?", response: this.activateAction });
      } else {
        this.animation();
        let qtd = this.qtd;
        if(qtd == 0){
          qtd = this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
          if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
            qtd = Number(Math.round((parseFloat(qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
            qtd = qtd < 1 ? 1 : qtd;
            qtd = this.verifyMinimum(qtd, qtd);
          }
        } else {
          let q = (this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1);
          if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
            q = Number(Math.round((parseFloat(q) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
            q = q < 1 ? 1 : q;
          }
          qtd = parseFloat(qtd) + parseFloat(q);
        }
        if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
          this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        } else {
          this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
            this.qtd_buffer = 0;
            this.emitter.emit('sendCart');
          }.bind(this));
        }
      }
    },
    removeItem(){
      let qtd = this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1;
      if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
        qtd = Number(Math.round((parseFloat(qtd) / parseFloat(this.product.cfg.net_weight)) + 'e0') + 'e-0');
        qtd = qtd < 1 ? 1 : qtd;
      }
      qtd = this.verifyMinimum(parseFloat((parseFloat(this.qtd) - parseFloat(qtd)).toFixed(3)), qtd);
      this.updateItemCart({ item: this.product, qtd: parseFloat((parseFloat(this.qtd) - parseFloat(qtd)).toFixed(3)), kgund: this.kgund }).then(function (){
        this.qtd_buffer = 0;
        this.emitter.emit('sendCart');
      }.bind(this));
    },
    removeAll(){
      this.updateItemCart({ item: this.product, qtd: 0 }).then(function (){
        this.emitter.emit('sendCart');
      }.bind(this));
    },
    verifyMinimum(qtd, qtd_nova){
      let qtd_temp = qtd_nova;
      if(this.product.cfg != null){
        if(this.product.is_kg == 1 && this.product.cfg.net_weight > 0 && this.kgund == 0){
          if(qtd < Number(Math.round((this.product.cfg.minimum_amount / this.product.cfg.net_weight) + 'e0') + 'e-0')){
            qtd_temp = parseFloat(qtd) + parseFloat(qtd_nova);
          }
        } else {
          if(qtd < this.product.cfg.minimum_amount){
            qtd_temp = parseFloat(qtd) + parseFloat(qtd_nova);
          }
        }
      }
      return qtd_temp;
    },
    removeFamily(){
      this.removeAllFamily(this.product.offer.offer_id).then(function(){
        this.emitter.emit('sendCart');
      }.bind(this))
    },
    setLike(){
      this.setLikeProduto(this.product.sku);
    },
    removeLike(){
      this.removeLikeProduto(this.product.sku);
    },
    chooseItem(){
      this.loadFamily(this.product.offer.offer_id).then(function(){
        this.modelFamily = true;
      }.bind(this));
    },
    fechar: function(){
      this.modelFamily = false;
    },
    isHidden(el) {
        return el.is(':visible');
    },
    animation(){
      var cart = null;
      if(this.isHidden(jQuery('#cart-button2'))){
          cart = document.getElementById('cart-button2');
      } else if(this.isHidden(jQuery('#cart-button1'))){
          cart = document.getElementById('cart-button1');
      }
      var y = 20;
      var x = 50;
      if(cart == null){
          cart = document.getElementById('cart-button-mobile');
          x = 0;
          y = 0;
      }
      if(cart != null){
        cart = cart.getBoundingClientRect();
        var imgtodrag = jQuery("#"+this.product.sku).eq(0);
        var imgtodragposition = document.getElementById(this.product.sku);
        imgtodragposition = imgtodragposition.getBoundingClientRect();
        if (imgtodrag) {
          var imgclone = imgtodrag.clone().offset({
              top: imgtodragposition.top + 20,
              left: imgtodragposition.left + 20,
          }).css({
              'opacity': '0.8',
              'position': 'fixed',
              'height': '150px',
              'width': '150px',
              'border-radius': '100%',
              'z-index': '1000'
          }).appendTo(jQuery('body'));
          imgclone.animate({
              'opacity': '0.3',
              'top': cart.top + y,
              'left': cart.left + x,
              'width': 50,
              'height': 50
          }, 800);
          imgclone.animate({
              'width': 0,
              'height': 0
          }, function () {
              imgclone.detach()
          });
        }
            
        setTimeout (function(){
            jQuery('.cart-button').addClass('shake-cart-button');
        },700);
        setTimeout (function(){
            jQuery('.cart-button').removeClass('shake-cart-button');
        },1200);
      }
    },
  },
  mounted(){
    if(this.item && this.item.cart){
      this.qtd = this.item.cart.amount;
      this.kgund = this.item.cart.type_unit;
    } else {
      this.qtd = this.product.offer != null && this.product.offer.is_offer_family == 1 ? this.getTotalFamily(this.product.offer.offer_id): 0;
      this.kgund = this.product.is_kg == 1;
    }
    if(this.notImage == false){
      this.getImage({ sku: this.product.sku, imghash: "t-"+this.product.imghash });
    }
    this.checkLayout();
    window.addEventListener("resize", this.checkLayout);
  },
  unmounted(){
    window.removeEventListener("resize", this.checkLayout);
  }
}
</script>
